module.exports = __webpack_public_path__ + "static/giraffe_fullLogo_goldBlue copy-c931b6e4fadf2ae63a8894f18bae27d7.png";